"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateWithSchema = validateWithSchema;
const valibot_1 = require("valibot");
/**
 * 쿼리 파라미터를 스키마에 따라 검증하는 유틸리티 함수
 *
 * @template T - valibot 스키마 입력 타입
 * @template O - valibot 스키마 출력 타입
 * @template I - valibot 에러 이슈 타입
 * @template R - 검증 실패 시 반환할 타입
 * @param schema - 검증에 사용할 Valibot 스키마
 * @param data - 검증할 쿼리 파라미터 등의 데이터
 * @param onError - 검증 실패 시 실행할 콜백 함수
 * @returns 검증된 데이터 또는 onError의 반환값
 */
function validateWithSchema(schema, data, onError) {
    const result = (0, valibot_1.safeParse)(schema, data);
    if (!result.success) {
        return onError(result.issues);
    }
    return result.output;
}
